import { render } from "./HeroHeader.vue?vue&type=template&id=93a6aa3e&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=93a6aa3e&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a6aa3e"]])

export default __exports__